import { Navigate } from 'react-router-dom'
import { useMe } from '../api'

function hasLoggedInCookie(): boolean {
  return document.cookie.includes('logged_in=1')
}

/**
 * Admin-only guard. Gates the /staff/* subtree.
 *
 * Auth flow:
 *   1. No logged_in cookie → redirect to /staff/login. Quick pre-check.
 *   2. useMe() pending → spinner.
 *   3. 401 / error → /staff/login.
 *   4. role === 'operator' → bounce to / (operator side).
 *   5. role === 'admin' → render children.
 */
export function RequireAdminAuth({ children }: { children: React.ReactNode }) {
  const { data, isPending, isError } = useMe()
  if (!hasLoggedInCookie()) return <Navigate to="/staff/login" replace />
  if (isPending) return <AuthSpinner />
  if (isError || !data) return <Navigate to="/staff/login" replace />
  if (data.role === 'operator') return <Navigate to="/" replace />
  if (data.role !== 'admin') return <Navigate to="/staff/login" replace />
  return <>{children}</>
}

function AuthSpinner() {
  return (
    <div
      role="status"
      aria-label="Loading"
      className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-950"
    >
      <div className="w-6 h-6 rounded-full border-2 border-gray-300 dark:border-gray-700 border-t-blue-500 animate-spin" />
    </div>
  )
}
